export enum BoxConsumableStatus {
  PENDING_PAYMENT = "PENDING_PAYMENT",
  PAID = "PAID",
  INACTIVE = "INACTIVE",
}
